module.exports=function(scope){ return `<div style="height: 100%;">
    <iframe title="" class="${scope.previewClass}" src="${scope.url}" wmode="transparent"></iframe>
    ${scope.links}
</div>`};